module.exports = __webpack_public_path__ + "20d9b25f42672bcaa49f644442d57dcf.png";